import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-taskEdit",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class TaskEditButtonComponent extends EceButtonComponent {
  icon = "track-changes-accept";
}
